import React, {Component} from 'react';
import {injectIntl} from 'react-intl';

import Icon from 'components/Icon';

class PasswordVisibility extends Component {
  render() {
    const {togglePassword, showPassword, password} = this.props;
    if (!password) {
      return null;
    }
    const iconName = showPassword ? 'eye-slash-solid' : 'eye-solid';

    return (
      <div onClick={togglePassword} data-testid={iconName}>
        <Icon name={iconName} size={20} />
      </div>
    );
  }
}

export default injectIntl(PasswordVisibility);
